export const rollState = [
    {
        id: 0,
        name: 'Greig',
        value: 'greig'
    },
    {
        id: 1,
        name: 'Offsite',
        value: 'offsite'
    },
    {
        id: 2,
        name: 'Finished',
        value: 'finished'
    },
    {
        id: 3,
        name: 'Available',
        value: 'available'
    },
    {
        id: 4,
        name: 'Dispatched',
        value: 'dispatched'
    }
]

export const getRollState = (id: number) => {
    const roll = rollState.find(roll => roll.id === id)
    return roll?.name || 'Unknown'
}